import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c4c55ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "purchase-order-material-select hmd-btn" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("源单导入")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_button, {
      disabled: !_ctx.contractId,
      type: "primary",
      onClick: _ctx.showModal
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["disabled", "onClick"])
  ]))
}